import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { business } from "../../data/business";
import { faqs } from "../../data/home";
import { SectionHeading } from "../ui/SectionHeading";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" aria-labelledby="faq-title" className="section-y gutter scroll-mt-28 bg-sand" data-id="element-192" data-mp="2a1mr3hvm7unn">
      <div className="grid gap-[clamp(3rem,6vw,8rem)] lg:grid-cols-[0.8fr_1.2fr]" data-id="element-193" data-mp="1v8l0oa3s6jaf">
        <div className="lg:sticky lg:top-32 lg:h-fit" data-id="element-194" data-mp="206uuohdrrdug">
          <SectionHeading id="faq-title" eyebrow="Questions families ask" title={<>
                Nevada bail, <em className="text-gold-hover" data-id="element-196" data-mp="1r6zf80d6kwom">in plain English.</em>
              </>} data-id="element-195" data-mp="1m6bt9t3t7619" />
          <p className="mt-6 text-lg text-muted" data-id="element-197" data-mp="3ghyupyh7i4qm">
            Still unsure? Call{" "}
            <a href={business.phoneHref} className="font-semibold text-navy underline-offset-4 hover:underline" data-id="element-198" data-mp="3lgtmvr12d5ne">
              {business.phoneDisplay}
            </a>{" "}
            — consultations are always free.
          </p>
        </div>

        <ul className="border-t border-gold/40" data-id="element-199" data-mp="2x6a9br8lr6ux">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          return <li key={f.q} className="border-b border-gold/40" data-id="element-200" data-mp="24gtopfr84u99" data-mpi={i}>
                <h3 data-id="element-201" data-mp="24j62rhtv2kh1">
                  <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex min-h-[64px] w-full items-center justify-between gap-6 py-6 text-left font-serif text-[clamp(1.25rem,1.6vw,1.6rem)] text-navy transition-colors duration-150 hover:text-gold-hover" data-id="element-202" data-mp="20fhvl0955qwb">
                    {f.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-gold-hover transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-203" data-mp="3kxfqc9qa456t" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-204" data-mp="5rup2b4fadk0">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.22, 1, 0.36, 1]
              }} className="overflow-hidden" data-id="element-205" data-mp="apcys3q9kwt2">
                      <p className="measure pb-7 text-lg text-muted" data-id="element-206" data-mp="3nxzllavppoob">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}